var ssm = window.ssm || {};

(function (ssm) {
  'use strict';

	ssm.breadcrumbs = function(element) {
		var $element = $(element);
    if(!$element) return;
    
    var breadcrumbsObj = {}
    breadcrumbsObj.element = $element;

    var $ol = $(breadcrumbsObj.element).find('ol');
    var $mobileBack = $(breadcrumbsObj.element).find('.mobile-back')

    breadcrumbsObj.showMobileBreadcrumbs = function (el) {
      $ol.attr('aria-hidden', 'true')
      $mobileBack.attr('aria-hidden', 'false')
    };

    breadcrumbsObj.showDesktopBreadcrumbs = function (el) {
      $mobileBack.attr('aria-hidden', 'true')
      $ol.attr('aria-hidden', 'false')
    };

    return breadcrumbsObj;


	};
})(window.ssm);
